import { inject, Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { App } from '@df/core/app';
import { NPitchPrint } from './pitch-print.namespace';

@Injectable({
    providedIn: 'root'
})
export class PitchPrintService {
    private requestService = inject(RequestService);

    private sessionStorageService = inject(SessionStorageService);

    private app = inject(App);

    private async load() {
        await this.requestService.loadScriptAsync(NPitchPrint.EAssets.jquery);
        await this.requestService.loadScriptAsync(NPitchPrint.EAssets.client);
    }

    async createClient(config: Partial<NPitchPrint.IClientConfig>) {
        const apiKey = this.app.data.pitchPrint?.apiKey?.find(key => !!key);
        if (!apiKey) {
            throw new Error('No pitch print api key found');
        }
        await this.load();
        if (PitchPrintClient) {
            const clientConfig = { ...this.getDefaultConfig(apiKey), ...config };
            const client = new PitchPrintClient(clientConfig);
            return client;
        }
    }

    private getDefaultConfig(apiKey: string): NPitchPrint.IClientConfig {
        return {
            apiKey,
            uploadUrl: 'url_pending',
            userId: '1',
            langCode: 'en',
            enableUpload: 0,
            previews: '',
            mode: 'new',
            createButtons: true,
            pluginRoot: 'path_pending',
            client: 'mg'
        };
    }

    addProjectToStorage(productId: number, project: NPitchPrint.IProject) {
        const storageData = this.getProjectsFromStorage();
        storageData[productId] = project;
        this.sessionStorageService.set('pitchPrintProjects', storageData);
    }

    removeProjectFromStorage(productId: number): void {
        const storageData = this.getProjectsFromStorage();
        delete storageData[productId];
        this.sessionStorageService.set('pitchPrintProjects', storageData);
    }

    getProjectsFromStorage(): NPitchPrint.TIStorageData {
        return this.sessionStorageService.get('pitchPrintProjects') || {};
    }
}
